import { render } from "./SvgChannelDraw.vue?vue&type=template&id=5be8b522&scoped=true&ts=true"
import script from "./SvgChannelDraw.vue?vue&type=script&lang=ts"
export * from "./SvgChannelDraw.vue?vue&type=script&lang=ts"

import "./SvgChannelDraw.vue?vue&type=style&index=0&id=5be8b522&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ga38som\\IdeaProjects\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be8b522"]])

export default __exports__